import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';

import { of, take } from 'rxjs';

import { UserService } from '~app/services/user.service';

import { UserForm } from '../user.form';
import { MatCard, MatCardContent, MatCardActions } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


@Component({
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	imports: [
		MatCard,
		MatCardContent,
		FormsModule,
		ReactiveFormsModule,
		MatFormField,
		MatLabel,
		MatInput,
		MatError,
		MatCardActions,
		MatButton,
		MatProgressSpinner
	]
})
export class UserLoginComponent implements OnInit {
	public readonly form = (new UserForm).login();
	public readonly loading = signal(false);
	public readonly error = signal(false);
	public readonly cardOpen = signal(false);

	constructor(
		private readonly _router: Router,
		private readonly _user: UserService,
	) {}

	public ngOnInit(): void {
		if (this._user.isLogged()) of(this._router.navigate(['/']));
		setTimeout(() => this.cardOpen.set(true), 500);
	}

	public loginSubmit() {
		if (!this.form.valid) return;
		this.form.disable();
		this.loading.set(true);
		this.error.set(false);
		this._user.login(
			this.form.controls.email.value,
			this.form.controls.password.value,
		).pipe(take(1)).subscribe({
			next: (logged) => {
				if (logged) {
					this.cardOpen.set(false);
					of(this._router.navigate(['/user/dashboard']));
				} else {
					this.loading.set(false);
					this.error.set(true);
					this.form.enable();
				}
			},
			error: () => {
				this.loading.set(false);
				this.error.set(true);
				this.form.enable();
			},
		});
	}
}
